import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { GetServerSideProps } from 'next';
import { HeadSection } from 'components/HeadSection';
import { AboveTheFold, DiscoveryBlocks } from '../organisms';
import { DiscoveryBlock, PageTypeEnum } from 'types';
import { useHomePage, useIdentifiedPage } from 'hooks';
import { transformBlock, ServiceContainer, findBlockByType } from 'helpers';
import { logger } from '@teko/log';
import { MenuItem } from '@teko/discovery';

const PopupPromotion = dynamic(() =>
  import('../../PopupPromotion').then((mod) => mod.PopupPromotion),
);

interface HomeProps {
  serverBlocks: DiscoveryBlock[];
  sideBanner?: React.ReactNode;
  menuItems?: MenuItem[];
}

export const Home: React.FC<HomeProps> = ({
  serverBlocks,
  sideBanner,
  menuItems,
}: HomeProps) => {
  const {
    slideBanners,
    topRightBanners,
    blocks,
    popupBanner,
    horizontalFourBanners,
  } = useHomePage(serverBlocks);

  const showPopupBanner = popupBanner && popupBanner?.cookedData?.[0];

  useIdentifiedPage('homePage');

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <>
      {showPopupBanner && <PopupPromotion banner={popupBanner.cookedData[0]} />}
      <HeadSection />
      <AboveTheFold
        menuItems={findBlockByType('MEGA_MENU', blocks) ? menuItems : []}
        slideBanners={slideBanners}
        topRightBanners={topRightBanners}
        horizontalFourBanners={horizontalFourBanners}
      />
      {sideBanner}
      <DiscoveryBlocks blocks={blocks} />
    </>
  );
};

export const getServerSidePropsHome: GetServerSideProps = async (
  context: any,
) => {
  const terminalCode = (context.req as any).terminal;
  const { discoveryService } = new ServiceContainer(
    (context.req as any).tenantEnv,
  );
  try {
    const data = await discoveryService.getBlock({
      pageTypeEnum: PageTypeEnum.HOME,
      terminalCode: terminalCode,
    });
    return {
      props: {
        serverBlocks: data?.result?.blocks?.map(transformBlock) || [],
      },
    };
  } catch (e: any) {
    logger.error(context.req, e);
    return {
      props: {
        serverBlocks: [],
      },
    };
  }
};
